/**
 * Offsets are typed the way a rundown is read out loud.
 *
 *   "20"       -> 20 minutes   (a bare number is minutes, not seconds:
 *                               breaks are planned in minutes)
 *   "1:30"     -> 1m 30s
 *   "1:02:03"  -> 1h 2m 3s
 */
export function parseOffset(input) {
    const trimmed = input.trim();
    if (!trimmed)
        return null;
    const parts = trimmed.split(":");
    if (parts.length > 3)
        return null;
    if (parts.some((part) => part === "" || !/^\d+$/.test(part)))
        return null;
    const numbers = parts.map(Number);
    if (numbers.some((n) => !Number.isFinite(n)))
        return null;
    if (numbers.length === 1)
        return numbers[0] * 60;
    if (numbers.length === 2) {
        const [minutes, seconds] = numbers;
        if (seconds > 59)
            return null;
        return minutes * 60 + seconds;
    }
    const [hours, minutes, seconds] = numbers;
    if (minutes > 59 || seconds > 59)
        return null;
    return hours * 3600 + minutes * 60 + seconds;
}
/** Seconds back to the shortest form that round-trips: m:ss or h:mm:ss. */
export function formatOffset(totalSeconds) {
    const sign = totalSeconds < 0 ? "-" : "";
    const total = Math.abs(Math.round(totalSeconds));
    const hours = Math.floor(total / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;
    const pad = (n) => String(n).padStart(2, "0");
    return hours > 0
        ? `${sign}${hours}:${pad(minutes)}:${pad(seconds)}`
        : `${sign}${minutes}:${pad(seconds)}`;
}
